import { SearchFacetValueVisual } from "@nosto/nosto-js/client";

type Props = {
  value: string;
  selected: boolean;
  onChange: (e: Event) => void;
  className?: string;
  visual: SearchFacetValueVisual | undefined;
  label: string;
  count: number;
};

export default function Checkbox({
  label,
  selected,
  onChange,
  visual,
  count,
}: Props) {
  return (
    <label>
      <input
        type="checkbox"
        checked={selected}
        onChange={onChange}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onChange(e);
          }
        }}
      />
      {visual && (
        <span
          className="filter-color-swatch"
          style={
            visual.type === "thumbnail"
              ? { backgroundImage: `url(${visual?.value})` }
              : { backgroundColor: visual?.value }
          }
        />
      )}
      <span>{label}</span>
      <span>({count})</span>
    </label>
  );
}
